const EXPIRE_KEY = 'tokenExpire'; // token 过期时间 key
const USERID_KEY = 'userID'; // userID key

/**
 * 检测浏览器是否具有 localStorage
 * @returns 存在 ? localStorage : false
 */
let supportStorage = () => {
  let ls = window.localStorage;

  if (ls) {
    return ls;
  } else {
    alert("不支持 localStorage");
    return false;
  }
}

/**
 * 获取 LocalStorage 对应项
 * @param {String} id 工程师 id
 */
let getStorageItem = (key) => {
  let ls = supportStorage();

  return ls ? ls.getItem(key) : false;
}

/**
 * 设置 LocalStorage 对应项
 * @param {String} id 工程师 id
 */
let setStorageItem = (key, value) => {
  let ls = supportStorage();

  ls ? ls.setItem(key, value) : '';
}

/**
 * 删除 LocalStorage 对应项
 * @param {String} key LocalStorage key
 */
let removeStorageItem = (key) => {
  let ls = supportStorage();

  ls ? ls.removeItem(key) : '';
}

export {
  getStorageItem,
  setStorageItem,
  removeStorageItem,
  USERID_KEY,
  EXPIRE_KEY
}